// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC3mK1nUiaF4zU4Z8VQvZ4kINybmB46AQo",
  authDomain: "channel-talks-web.firebaseapp.com",
  projectId: "channel-talks-web",
  storageBucket: "channel-talks-web.appspot.com",
  messagingSenderId: "1032709066703",
  appId: "1:1032709066703:web:a56bb0b76393bbc1884cba"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)